import _ from 'lodash'

/*
 * 空字符占位
 *
 * */
export function emptyReplace (str) {
  /**
   * 检查值是否为空（null、undefined、空字符串）
   */
  const isEmpty = (value) => {
    // null 或 undefined
    if (value == null) return true

    // 空字符串
    if (value === '') return true

    // 数字类型：0 算空值，其他数字不算空值
    if (typeof value === 'number') return value === 0

    // 布尔类型：不算空值
    if (typeof value === 'boolean') return false

    // 其他类型使用 lodash 的 isEmpty
    return _.isEmpty(value)
  }
  return isEmpty(str) ? '-' : str
}

/*
 * 性别
 * 2 女 1 男
 * */
export function genderCode (str) {
  if (str === '2' || str === 2 || str === 'man') {
    return '男'
  } else if (str === '3' || str === 3) {
    return '女'
  } else {
    return str
  }
}

/*
 * 性别
 * 0 正常、1 冻结、9 未参保
 * */
export function YiBaoFundState (str) {
  if (str === '0' || str === 0) {
    return '正常'
  } else if (str === '1' || str === 1) {
    return '冻结'
  } else if (str === '9' || str === 9) {
    return '未参保'
  } else {
    return str
  }
}
